/**
 * הקראה לילדים - דיבור של טקסט בעברית בלחיצה (Web Speech API).
 */

let currentUtterance = null

/**
 * מחזיר טקסט מתאים להקראה מאלמנט שנלחץ (כפתור, קישור, תווית).
 */
export function getTextToSpeak(el) {
  if (!el || typeof el.closest !== 'function') return ''
  const button = el.closest('button, [role="button"], a, [role="link"]')
  const target = button || el
  const speak = target.getAttribute?.('data-speak')
  if (speak && speak.trim()) return speak.trim()
  const ariaLabel = target.getAttribute?.('aria-label')
  if (ariaLabel && ariaLabel.trim()) return ariaLabel.trim()
  const title = target.getAttribute?.('title')
  if (title && title.trim()) return title.trim()
  let text = ''
  if (target.innerText) text = target.innerText
  else if (target.textContent) text = target.textContent
  text = (text || '').trim().replace(/\s+/g, ' ')
  if (text.length > 120) text = text.slice(0, 117) + '...'
  return text
}

/**
 * עוצר הקראה נוכחית.
 */
export function cancelSpeech() {
  if (typeof window !== 'undefined' && window.speechSynthesis) {
    window.speechSynthesis.cancel()
  }
  currentUtterance = null
}

/**
 * מקריא טקסט בעברית. משתמש ב־he-IL אם קיים, אחרת קול ברירת מחדל.
 */
export function speakHebrew(text) {
  if (!text || typeof window === 'undefined' || !window.speechSynthesis) return
  cancelSpeech()
  const u = new SpeechSynthesisUtterance(text)
  u.rate = 0.95
  u.pitch = 1
  const voices = window.speechSynthesis.getVoices()
  const heVoice = voices.find((v) => v.lang === 'he-IL' || v.lang.startsWith('he-'))
  if (heVoice) u.voice = heVoice
  else u.lang = 'he-IL'
  currentUtterance = u
  window.speechSynthesis.speak(u)
}
